import { Box, Typography } from "@mui/material";
import React from "react";
import ExpertiseImageCard from "./ExpertiseImageCard";

const ExpertiseCard = ({ title, description, CardImage01, icon }) => {
  return (
    <Box
      sx={{
        maxWidth: "1440px",
        margin: "0 auto",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        padding: { xs: "1rem", sm: "2rem 3rem" },
        backgroundColor: "#ecebeb",
        gap: { xs: "1.5rem", sm: "3rem" },
      }}
    >
      {/* Left Content Section */}
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            width: { xs: "3rem", sm: "4rem" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <img
            src={icon}
            alt="Icon"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
        <Typography
          variant="h4"
          sx={{
            color: "rgba(35, 35, 37, 1)",
            fontFamily: "Montserrat",
            fontSize: "1.2rem",
            fontWeight: 600,
            marginBottom: "0.8rem",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* Right Image Section */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" },
          alignItems: "center",
        }}
      >
        <Box sx={{ width: { xs: "auto", md: "70%" } }}>
          <img src={CardImage01} alt="" width="100%" />
        </Box>
      </Box>
    </Box>
  );
};

export default ExpertiseCard;
